"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENTERPRISE = exports.PROFESSIONAL = exports.STARTER = exports.FREE = void 0;
var FREE = 'free';
exports.FREE = FREE;
var STARTER = 'starter';
exports.STARTER = STARTER;
var PROFESSIONAL = 'professional';
exports.PROFESSIONAL = PROFESSIONAL;
var ENTERPRISE = 'enterprise';
exports.ENTERPRISE = ENTERPRISE;